import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en' // 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import api from './api'
import axios from 'axios'
import tool from './utils/tool'
import moment from 'moment' // 导入时间过滤器
import audio from 'vue-mobile-audio' // 引入amr播放器
import VueCropper from 'vue-cropper'
import { parseTime } from '@/utils/index.js'

Vue.use(VueCropper)
import './icons' // icon
import './icons/iconfont.css' // 引入iconfont图标
import './icons/iconfont2.css'

import './permission' // 权限指令
import './utils/error-log' // error log

import * as filters from './filters' // global filters

import AMap from 'vue-amap'

import DoubleCheck from './components/DoubleCheck/index'
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

Vue.component('DoubleCheck', DoubleCheck)

Vue.use(audio)
Vue.use(AMap) // 引入高德组件
Vue.use(Element, {
  size: Cookies.get('size') || 'mini', // set element-ui default size
  zIndex: 500
})
Vue.prototype.$api = api
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.prototype.$tool = tool
Vue.prototype.$parseTime = parseTime

// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '208a91f282163343dcada47ee7da3eb2',
  // 插件集合 （插件按需引入）
  plugin: [
    'Autocomplete',
    'PlaceSearch',
    'Scale',
    'OverView',
    'ToolBar',
    'MapType',
    'PolyEditor',
    'AMap.CircleEditor'
  ]
})

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
})
